import React, { useEffect, useState } from "react";
import { 
  Flex, 
  Text, 
  useColorModeValue,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  useDisclosure,
  Box
} from "@chakra-ui/react";

const WelcomeUsers = () => {
  const textColor = useColorModeValue("gray.700", "white");
  const { isOpen, onOpen, onClose } = useDisclosure();

  const OverlayOne = () => (
    <ModalOverlay bg='blackAlpha.500' backdropFilter='blur(0.5px)' />
  );

  const [overlay] = useState(<OverlayOne />);

  useEffect(() => {
    onOpen();
  }, []);

  // Feature card component for each vertical
  const FeatureCard = ({ icon, title, items, accentColor, bgGradient }) => (
    <Box
      flex="1"
      bg="white"
      borderRadius="16px"
      p={4}
      border="1px solid"
      borderColor="gray.100"
      boxShadow="0 2px 8px rgba(0,0,0,0.06)"
      transition="all 0.2s ease"
      _hover={{
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      }}
    >
      <Flex align="center" mb={3}>
        <Box
          w="36px"
          h="36px"
          borderRadius="10px"
          bg={bgGradient}
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="lg"
          mr={3}
        >
          {icon}
        </Box>
        <Text fontWeight="700" fontSize="md" color={accentColor}>
          {title}
        </Text>
      </Flex>
      <Box as="ul" pl={4} fontSize="sm" color="gray.600" lineHeight="1.8">
        {items.map((item, idx) => (
          <Box as="li" key={idx} listStyleType="disc" _marker={{ color: accentColor }}>
            {item}
          </Box>
        ))}
      </Box>
    </Box>
  );

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose} size="2xl">
      {overlay}
      <ModalContent 
        marginLeft={{ xl: "250px", md: "0px" }}
        width={{ sm: "95%", md: "90%" }}
        borderRadius="24px"
        overflow="hidden"
        mx={4}
      >
        <ModalHeader pb={2} pt={6}>
          <Text
            fontSize='2xl'
            color={textColor}
            fontWeight='bold'
            textAlign='center'
          >
            Welcome to GRID AI
          </Text>
          <Text
            fontSize='sm'
            color="gray.500"
            fontWeight='normal'
            textAlign='center'
            mt={1}
          >
            Your intelligent assistant for Esports & Travel
          </Text>
        </ModalHeader>

        <ModalBody px={6} py={4}>
          <Flex 
            direction={{ base: "column", md: "row" }} 
            gap={4}
          >
            {/* Esports Card */}
            <FeatureCard
              icon="🎮"
              title="Esports"
              accentColor="#298BE2"
              bgGradient="linear(135deg, #298BE2 0%, #6eb2ef 100%)"
              items={[
                "Game info & recommendations",
                "Identify games by image",
                "Industry data & latest news",
                "Tournament management tips",
                "GRID platform guidance"
              ]}
            />

            {/* eJourney Card */}
            <FeatureCard
              icon="✈️"
              title="eJourney"
              accentColor="#1069B8"
              bgGradient="linear(135deg, #1069B8 0%, #298BE2 100%)"
              items={[
                "Discover top destinations",
                "Hotels & accommodation",
                "Hajj & Umrah planning",
                "Custom travel itineraries",
                "Local attractions & tips"
              ]}
            />
          </Flex>

          <Box 
            mt={5} 
            p={3} 
            bg="gray.50" 
            borderRadius="12px"
            textAlign="center"
          >
            <Text fontSize="sm" color="gray.500">
              💡 Use the toggle at the top to switch between modes
            </Text>
          </Box>
        </ModalBody>

        <ModalFooter justifyContent="center" pb={6} pt={2}>
          <Button
            bg='#298BE2'
            fontSize='15px'
            color='white'
            fontWeight='600'
            borderRadius="full"
            w='60%'
            h='48px'
            _hover={{
              bg: '#1069B8',
            }}
            _active={{
              bg: '#0d5a9e',
            }}
            transition="all 0.2s ease"
            onClick={onClose}
          >
            Get Started
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default WelcomeUsers;